const navBarData = [
  {
    id: 1,
    name: 'Events & Event-Related Collateral',
    image: '1-0-eventsandMarketingMaterials.jpg',
    roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
    link: '',
    isCollapsed: true,
    subcategories: [
      {
        id: 2,
        name: 'Events',
        image: '1-1-events.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        link: '/events',
        subcategories: [],
        items: []
      },
      {
        id: 4,
        name: 'Event-Related Collateral',
        image: '1-3-eventRelatedCollateral.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        link: '',
        subcategories: [],
        items: [
          {
            id: '',
            name: 'Event Waiver',
            description: '',
            image: '4-2-eventWaiver.jpg',
            roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
            type: 'file',
            info: 'eventwaiver.pdf',
            preview: 'eventwaiver.pdf'
          },
          {
            id: '',
            name: 'Generic Voice Shot Script',
            description: '',
            image: '4-3-genericVoiceShot.jpg',
            roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
            type: 'file',
            info: 'EventVoiceShotScript_NonPreferredVendor_Nov2022.pdf',
            preview: 'EventVoiceShotScript_NonPreferredVendor_Nov2022.pdf'
          },
          {
            id: '',
            name: 'Heart Disease/Stroke Handout',
            description: '',
            image: '4-5-heartDiseaseStrokeHandout.jpg',
            roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
            type: 'product',
            info: '0DDDF4AD-998C-4567-A56D-5E11EB7909E2', // variable
            sku: 'MD.51357',
            preview: ''
          },
          {
            id: '',
            name: 'Let’s Beat Skin Cancer Handout',
            description: '',
            image: '4-6-letsBeatSkinCancerHandout.jpg',
            roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
            type: 'product',
            info: '5BF22332-B7B9-4869-AD45-9524B84B27B7', // static
            sku: 'MD.51358',
            preview: ''
          },
          /*{
            id: '',
            name: 'MDVIP Connect Flyer',
            description: '',
            image: '4-7-connectFlyer.jpg',
            roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
            type: 'product',
            info: '33804B82-6667-4901-AD3B-DC9332A409AE', // static
            sku: 'MD.64461',
            preview: ''
          },*/
          {
            id: '',
            name: 'Name Badge Labels (3.5" x 2.5")',
            description: '',
            image: '4-9-nameBadgeLabels.jpg',
            roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
            type: 'product',
            info: '1120CBD2-639A-4746-B69C-7DA7396A4D4B', // static
            sku: 'MD.53534'
          },
          {
            id: '',
            name: 'Longevity Handout',
            description: '',
            image: '4-11-longevityHandout.jpg',
            roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
            type: 'product',
            info: 'MD51359-POD', // static
            sku: 'MD.51359-POD', // missing
            preview: ''
          },
          {
            id: '',
            name: 'Gut Health Handout',
            description: '',
            image: '4-12-gutHealthHandout.jpg',
            roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
            type: 'product',
            info: 'MD64664-POD', // static
            sku: 'MD.64664-POD',
            preview: ''
          }
        ]
      }
    ],
    items: []
  },
  {
    id: 5,
    name: 'Wellness Program Materials',
    image: '5-0-wellnessProgramMaterials.jpg',
    roles: ['regular'],
    link: '',
    subcategories: [],
    items: [
      {
        id: '',
        name: 'Wellness Program Folder', // custom order limit
        description: '', // Temporarily out of stock, will be available the week of the 11/08/21.
        image: '5-1-wpFolderKit.jpg',
        roles: ['regular'],
        type: 'product',
        sku: 'MD.64540-KIT',
        preview: ''
      },
      /*{
        id: '',
        name: 'Wellness Program Folder', // custom order limit
        description: 'Only a quantity of 50 may be ordered temporality at this time. Thank you for your patience', // Temporarily out of stock, will be available the week of the 11/08/21.
        image: '5-1-wpFolder.jpg',
        roles: ['regular'],
        type: 'product',
        info: '0912CA32-9266-4B02-B4E0-CBBFF3BCF608', // static
        sku: 'MD.64540',
        preview: ''
      },
      {
        id: '',
        name: 'Pre-Wellness Checklist',
        description: '',
        image: '5-2-mdvip_standard_prewellnessChecklist_1220.jpg',
        roles: ['regular'],
        type: 'product',
        info: '82E756E2-5D8B-441B-B281-473853AFE714', // variable
        sku: 'MD.61367',
        preview: ''
      },
      {
        id: '',
        name: 'Annual Wellness Reminder Postcard',
        description: '',
        image: '5-3-wellnessPrograms_reminderPostcard.jpg',
        roles: ['regular'],
        type: 'product',
        info: '83D31E03-F16E-4FE2-923A-59FFE07C2A8F', // variable
        sku: 'MD.64554',
        preview: ''
      },*/
      // {
      //   id: '',
      //   name: 'Brain Health',
      //   description: '',
      //   image: '5-4-brainHealth.jpg',
      //   roles: ['regular'],
      //   type: 'product',
      //   sku: 'MD.69999',
      //   preview: ''
      // },
      // {
      //   id: '',
      //   name: 'Personal Medication Program Flyer',
      //   description: '',
      //   image: '5-4-personal-medication-program-flyer.jpg',
      //   roles: ['regular'],
      //   type: 'product',
      //   info: '',
      //   sku: 'MD.64687-POD',
      //   preview: ''
      // },
      {
        id: '',
        name: 'Brain Health Flyer',
        description: '',
        image: '5-5-brain-health-flyer.jpg',
        roles: ['regular'],
        type: 'product',
        info: '',
        sku: 'MD.64688-POD',
        preview: ''
      },
    ]
  },
  {
    id: 6,
    name: 'Wellness Program Plus Materials',
    image: '5-0-wellnessProgramMaterials.jpg',
    roles: ['plus'],
    link: '',
    subcategories: [],
    items: [
      {
        id: '',
        name: 'Wellness Program Folder', // custom order limit
        description: '', // Temporarily out of stock, will be available the week of the 11/08/21.
        image: '5-1-wpFolderKit.jpg',
        roles: ['plus'],
        type: 'product',
        sku: 'MD.64540-KIT',
        preview: ''
      },
      /*{
        id: '',
        name: 'Wellness Program Folder', // custom order limit
        description: 'Only a quantity of 50 may be ordered temporality at this time. Thank you for your patience', // Temporarily out of stock, will be available the week of the 11/08/21.
        image: '5-1-wpFolder.jpg',
        roles: ['plus'],
        type: 'product',
        info: '0912CA32-9266-4B02-B4E0-CBBFF3BCF608', // static
        sku: 'MD.64540',
        preview: ''
      },
      {
        id: '',
        name: 'Pre-Wellness Plus Checklist', // TODO - Not in Four51?
        description: '',
        image: '6-2-mdvip_wpp_prewellnessChecklist_1220.jpg',
        roles: ['plus'],
        type: 'product',
        info: 'E93CACCD-C644-4FE8-AF48-23AA8654E09A', // variable
        sku: 'MD.64528',
        preview: ''
      },
      {
        id: '',
        name: 'Annual Wellness Reminder Postcard',
        description: '',
        image: '5-3-wellnessPrograms_reminderPostcard.jpg',
        roles: ['plus'],
        type: 'product',
        info: '83D31E03-F16E-4FE2-923A-59FFE07C2A8F', // variable
        sku: 'MD.64554',
        preview: ''
      }*/
    ]
  },
  {
    id: 10,
    name: 'Women\'s Health Wellness Program Materials',
    image: '10-0-womensHealthWellness.jpg',
    roles: ['womens-health'],
    link: '',
    subcategories: [],
    items: [
      /*{
        id: '',
        name: 'Women\'s Health Pre-Wellness Checklist',
        description: '',
        image: '10-2-mdvip_whp_prewellnessChecklist_1220.jpg',
        roles: ['womens-health'],
        type: 'product',
        info: '7921B000-B0AB-4AAE-8B5E-E252292595DD', // variable
        sku: 'MD.64546',
        preview: ''
      },
      {
        id: '',
        name: 'Annual Wellness Reminder Postcard',
        description: '',
        image: '5-3-wellnessPrograms_reminderPostcard.jpg',
        roles: ['womens-health'],
        type: 'product',
        info: '83D31E03-F16E-4FE2-923A-59FFE07C2A8F', // variable
        sku: 'MD.64554',
        preview: ''
      },*/
      /* Peter Palacio, MD (6282) cannot see */
      {
        id: '',
        name: 'Women’s Health Program Referral Cards',
        description: '',
        image: '10-3-whp_referralcards.jpg',
        roles: ['womens-health'],
        type: 'product',
        info: 'MD64612', // variable
        sku: 'MD.64612'
      },
      /*{
        id: '',
        name: 'Women’s Health Program Folder',
        description: '',
        image: '10-4-whp_folder.jpg',
        roles: ['womens-health'],
        type: 'product',
        sku: 'MD.64689'
      },*/
      {
        id: '',
        name: 'Annual Wellness Program Folder Kit - Women\'s Health',
        description: '',
        image: '10-5-wpFolderKitWH.jpg',
        roles: ['womens-health'],
        type: 'product',
        sku: 'MD.AWP-WOMH-KIT'
      }
    ]
  },
  {
    id: 12,
    name: 'Endocrinology Wellness Program Materials',
    image: '12-5-wpFolderKitEndo.jpg',
    roles: ['endocrinology'],
    link: '',
    subcategories: [],
    items: [
      {
        id: '',
        name: 'Annual Wellness Program Folder Kit - Endo',
        description: '',
        image: '12-5-wpFolderKitEndo.jpg',
        roles: ['endocrinology'],
        type: 'product',
        sku: 'MD.AWP-ENDO-KIT'
      }
    ]
  },
  {
    id: 13,
    name: 'Men\'s Health Wellness Program Materials',
    image: '13-5-wpFolderKitMH.jpg',
    roles: ['mens-health'],
    link: '',
    subcategories: [],
    items: [
      {
        id: '',
        name: 'Annual Wellness Program Folder Kit - Men\'s Health',
        description: '',
        image: '13-5-wpFolderKitMH.jpg',
        roles: ['mens-health'],
        type: 'product',
        sku: 'MD.AWP-MENH-KIT'
      }
    ]
  },
  {
    id: 11,
    name: 'Wellness Program Materials',
    description: '',
    image: '5-0-wellnessProgramMaterials.jpg',
    roles: ['ascension-medical-group'],
    link: '',
    subcategories: [],
    items: [
      {
        id: '',
        name: 'Wellness Program Folder', // custom order limit
        description: '', // Temporarily out of stock, will be available the week of the 11/08/21.
        image: '5-1-wpFolderKit.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        sku: 'MD.64540-KIT',
        preview: ''
      },
      {
        id: '',
        name: 'Annual Wellness Program Folder Kit - Women\'s Health',
        description: '',
        image: '10-5-wpFolderKitWH.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        sku: 'MD.AWP-WOMH-KIT'
      },
      {
        id: '',
        name: 'Annual Wellness Program Folder Kit - Endo',
        description: '',
        image: '12-5-wpFolderKitEndo.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        sku: 'MD.AWP-ENDO-KIT'
      },
      {
        id: '',
        name: 'Annual Wellness Program Folder Kit - Men\'s Health',
        description: '',
        image: '13-5-wpFolderKitMH.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        sku: 'MD.AWP-MENH-KIT'
      },
      /*{
        id: '',
        name: 'AMG Annual Wellness Folder', 
        description: '',
        image: '11-1-AMG-Wellness-Folder.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        info: 'MD62557', // static
        sku: 'MD.62557',
        preview: ''
      },
      {
        id: '',
        name: 'Annual Wellness Reminder Postcard',
        description: '',
        image: '5-3-wellnessPrograms_reminderPostcard.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        info: '83D31E03-F16E-4FE2-923A-59FFE07C2A8F', // variable
        sku: 'MD.64554',
        preview: ''
      },*/
      {
        id: '',
        name: 'AMG Gait Speed Floor Decal', 
        description: '',
        image: '11-2-AMG-gait-speed.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        info: 'MD64594-PP', // static
        sku: 'MD.64594-PP',
        preview: ''
      },
      /*{
        id: '',
        name: 'Pre-Wellness Checklist',
        description: '',
        image: '5-2-mdvip_standard_prewellnessChecklist_1220.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        info: '82E756E2-5D8B-441B-B281-473853AFE714', // variable
        sku: 'MD.61367',
        preview: ''
      },
      {
        id: '',
        name: 'MDVIP Connect Flyer',
        description: '',
        image: '4-7-connectFlyer.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        info: '33804B82-6667-4901-AD3B-DC9332A409AE', // static
        sku: 'MD.64461',
        preview: ''
      },*/
      {
        id: '',
        name: 'MedJet Brochure',
        description: '',
        image: '11-3-medjet.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        info: 'MD64448-PPK', // static
        sku: 'MD.64448-PPK',
        preview: ''
      }
    ]
  },
  {
    id: 7,
    name: 'Member Retention Materials',
    image: '7-0-memberRetentionMaterials.jpg',
    roles: ['regular', 'plus', 'womens-health', 'ascension-medical-group', 'mens-health', 'endocrinology'],
    link: '',
    subcategories: [],
    items: [
      {
        id: '',
        name: 'Benefits of Membership Bifold Brochure',
        description: '',
        image: '7-1-bomBrochure.jpg',
        roles: ['regular', 'plus', 'womens-health', 'ascension-medical-group', 'mens-health', 'endocrinology'],
        type: 'product',
        info: '3712EA8C-9AE2-4C9E-8CD3-F41624578651', // static
        sku: 'MD.62516',
        preview: ''
      },
      {
        id: '',
        name: 'Acrylic Holder for BOM',
        description: '',
        image: '7-2-acrylic-holder.jpg',
        roles: ['ascension-medical-group'],
        type: 'product',
        info: 'MD62517', // static
        sku: 'MD.62517',
        preview: ''
      },
      /*{
        id: '',
        name: 'Connect Flyer',
        description: '',
        image: '4-7-connectFlyer.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        type: 'product',
        info: '33804B82-6667-4901-AD3B-DC9332A409AE', // static
        sku: 'MD.64461',
        preview: ''
      },
      {
        id: '',
        name: 'Birthday Cards',
        description: '',
        image: '7-7-birthdayCard2024.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        type: 'product',
        info: 'MD64682-PP', // static
        sku: 'MD.64682-PP',
        preview: ''
      }
     {
        id: '',
        name: 'Birthday Cards',
        description: 'Out of Stock, Check Back on 5/21/26',
        image: '7-7-birthdayCard2025.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        type: null, //'product',
        info: 'MD.64683-PP', // static
        sku: 'MD.64683-PP',
        preview: ''
      }*/
      {
        id: '',
        name: 'Birthday Cards',
        description: '',
        image: '7-7-birthdayCard2026.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        type: 'product',
        sku: 'MD.BIRTHDAYCARD-PP',
        preview: ''
      },
      {
        id: '',
        name: 'Holiday Card: Cheers to You!',
        description: '',
        image: '7-8-holidayCard2024.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        type: 'product',
        info: 'MD.64681-PP', // static
        sku: 'MD.64681-PP',
        preview: ''
      }
    ]
  },
  {
    id: 8,
    name: 'Practice Promotion Materials',
    image: '8-0-practicePromotionMaterials.jpg',
    roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
    link: '',
    subcategories: [],
    items: [
      {
        id: '',
        name: 'Referral Cards',
        description: '',
        image: '8-1-referralCards.jpg',
        roles: ['regular', 'plus'],
        type: 'products',
        info: [
          {
            Name: 'With Appointment Card',
            ID: 'A2C21292-3572-44B7-8CEB-F6929DB254FF', // variable
            sku: 'MD.52408'
          }, {
            Name: 'Without Appointment Card',
            ID: '49D4F31D-1A5B-435F-9094-070063F47B26', // variable
            sku: 'MD.52409'
          }
        ]
      },
      /*{
        id: '',
        name: 'Community Prospect Trifold',
        description: '',
        image: '8-3-communityProspectTrifold.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        type: 'product',
        info: 'AE13B4AA-EAE3-41D9-859C-00D766CEF508', // static
        sku: 'MD.52891'
      },
      {
        id: '',
        name: 'Personalized Banners', // TODO
        description: '',
        image: '8-5-personalizedBanners.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        type: 'link',
        info: ['/banners'], // variable MD.52715 & MD.52717
        action: 'Order Now'
      },*/
      {
        id: '',
        name: 'Referral Card Kit (w/o Appointment Card)',
        description: '',
        image: '8-2-referralCardKit.jpg',
        roles: ['regular', 'plus'],
        type: 'product',
        info: 'MD52410', //variable (52409) needed json
        sku: 'MD.52410'
      },
      {
        id: '',
        name: 'Membership Giveaway (Community Auction Events Only)',
        description: '',
        image: '8-2-membershipGiveaway.jpg',
        roles: ['regular'],
        type: 'link',
        info: ['/membership-giveaway'], // variable MD.52424
        action: 'Order Now'
        // MDVIP_MCertificate F.52425, F.52424 Personalized Gift Tag, Kitted Bags
        // A678D8E2-AD56-4B10-BB5B-08142796E227'
      }
      ,{
        id: '',
        name: 'Patient Reviews Cards (Pack of 50)',
        description: '',
        image: '8-6-PatientReviewsCard-2023.jpg',
        roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
        type: 'product',
        info: 'MD64660-PP', // static
        sku: 'MD.64660-PP'
      }
    ]
  },
  {
    id: 9,
    name: 'PowerPoint Library',
    image: '4-1-powerPointLibrary.jpg',
    roles: ['regular', 'plus', 'womens-health', 'mens-health', 'endocrinology'],
    link: ['/powerpoint-library'],
    action: 'View Library',
    subcategories: [],
    items: []
  }
];

export { navBarData };
